// extracted by mini-css-extract-plugin
export default {"main":"_1bfe912435","tit":"_258933535e","maintitle":"_6dd63d9017","ylw":"_372b4a38b2","white":"_2a09620232","mv_title":"_9fcebe17f2","mv_nc":"fc9cd6b6ac","mv_in":"f6ba73e5b6"};